"use client";

import { Menu, X } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState } from "react";
import { isBackendPath } from "@/shared/lib/backend-paths";

const NAV_ITEMS = [
  { label: "For private", href: "/privat" },
  { label: "For virksomheder", href: "/erhverv" },
  { label: "Sådan virker det", href: "/saadan-virker-det" },
  { label: "Priser", href: "/priser" },
  { label: "Bliv partner", href: "/bliv-partner" },
];

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const pathname = usePathname();

  if (isBackendPath(pathname)) {
    return null;
  }

  return (
    <header className="sticky top-0 z-40">
      {/* Dark theme-darker topbar - bookends the CTA-banner at page bottom */}
      <div className="h-[5px] bg-theme-darker" />

      <div className="border-b border-border bg-white">
        <div className="mx-auto flex max-w-page items-center justify-between gap-6 px-6 py-3.5">
          <Link href="/" className="font-serif text-lg leading-none tracking-[-0.01em]">
            <span className="font-bold text-theme-accent">rengøring</span>
            <span className="font-normal text-ink">idanmark.dk</span>
          </Link>

          <nav className="hidden items-center gap-6 lg:flex">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className="text-sm text-link underline decoration-link/30 underline-offset-[3px] hover:text-ink hover:decoration-ink"
              >
                {item.label}
              </Link>
            ))}
            <Link
              href="/tilbud"
              className="rounded bg-theme px-5 py-2.5 text-sm font-medium text-white hover:bg-theme-dark"
            >
              Find dit firma
            </Link>
          </nav>

          <button
            type="button"
            onClick={() => setMenuOpen(!menuOpen)}
            className="flex h-10 w-10 items-center justify-center text-ink lg:hidden"
            aria-label="Menu"
          >
            {menuOpen ? (
              <X className="h-5 w-5" aria-hidden="true" />
            ) : (
              <Menu className="h-5 w-5" aria-hidden="true" />
            )}
          </button>
        </div>

        {menuOpen && (
          <div className="border-t border-border bg-white px-6 pt-2 pb-4 lg:hidden">
            <nav className="flex flex-col gap-1">
              {NAV_ITEMS.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="py-2.5 text-sm text-link underline underline-offset-2 hover:text-ink"
                >
                  {item.label}
                </Link>
              ))}
              <Link
                href="/tilbud"
                onClick={() => setMenuOpen(false)}
                className="mt-2 rounded bg-theme px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-theme-dark"
              >
                Find dit firma
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
